import {defineCssVars} from '@chakra-ui/system';

export const vars = defineCssVars(`input`, [`border-radius`]);
